webpackJsonp([35783957827783],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hawkins-home.a810ada1.jpg";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n\n  @media (min-width: ', ') {\n    border: 10px solid ', ';\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n\n  @media (min-width: ', ') {\n    border: 10px solid ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 1.5rem;\n  text-align: center;\n  max-width: 48rem;\n  color: white;\n'], ['\n  padding: 1.5rem;\n  text-align: center;\n  max-width: 48rem;\n  color: white;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 2.5rem;\n'], ['\n  font-size: 2.5rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-size: 1.5rem;\n'], ['\n  font-size: 1.5rem;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _message = __webpack_require__(59);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _hawkinsHome = __webpack_require__(464);
	
	var _hawkinsHome2 = _interopRequireDefault(_hawkinsHome);
	
	var _theme = __webpack_require__(16);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Home = _styledComponents2.default.div(_templateObject, _hawkinsHome2.default, _theme2.default.app.mobileBreakpoint, _theme2.default.colors.bg);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var Heading = _styledComponents2.default.h1(_templateObject3);
	
	var Lead = _styledComponents2.default.p(_templateObject4);
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    Home,
	    null,
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        Heading,
	        null,
	        'Creative Landscape Design, Construction & Maintenance'
	      ),
	      _react2.default.createElement(
	        Lead,
	        null,
	        data.site.siteMetadata.title,
	        ', led by Landscape Designer Bob Hawkins, is the DC area\'s premier landscape design, build and service company.'
	      ),
	      _react2.default.createElement(
	        _message2.default,
	        null,
	        'Call to schedule a free estimate ',
	        data.site.siteMetadata.phone
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-b8b4ab186630c2f4d6fc.js